// src/api/sessions.js
import API from "../api";

const baseFor = (role) =>
  role === "ADMIN" ? "/admin" : role === "MANAGER" ? "/manager" : "/coach";

/**
 * Session APIs
 */

// Get sessions for a specific batch
export const listSessionsByBatch = (role, batchId, params = undefined) => {
  const base = `${baseFor(role)}/sessions/by-batch`;
  return API.get(`${base}/${batchId}`, params ? { params } : undefined);
};

// Create/Update (Admin)
export const createSession = (payload) => API.post(`/admin/sessions`, payload);
export const updateSession = (sessionId, payload) =>
  API.put(`/admin/sessions/${sessionId}`, payload);

// Create/Update (Manager)
export const createSessionManager = (payload) =>
  API.post(`/manager/sessions`, payload);
export const updateSessionManager = (sessionId, payload) =>
  API.put(`/manager/sessions/${sessionId}`, payload);

// Create/Update (Coach)
export const createSessionCoach = (payload) =>
  API.post(`/coach/sessions`, payload);
export const updateSessionCoach = (sessionId, payload) =>
  API.put(`/coach/sessions/${sessionId}`, payload);

// Generic list with filters
export const listSessions = (role, params = {}) =>
  API.get(`${baseFor(role)}/sessions`, { params });

// Fetch single session
export const getSession = (role, sessionId) =>
  API.get(`${baseFor(role)}/sessions/${sessionId}`);

// Update session status
export const setSessionStatus = (role, sessionId, status) =>
  API.patch(`${baseFor(role)}/sessions/${sessionId}/status`, { status });

// Reverse a completed session
export const reverseSession = (role, sessionId, reversalReason) =>
  API.post(`${baseFor(role)}/sessions/${sessionId}/reverse`, {
    reversalReason,
  });

// === NEW: Recurring creation ===
/**
 * createRecurringSessions(role, {
 *   batchId, coachId?, startTime, endTime, fromDate, toDate
 * })
 */
export const createRecurringSessions = (role, payload) =>
  API.post(`${baseFor(role)}/sessions/recurring`, payload);

// Calendar endpoint — all sessions in a date range
export const listSessionsCalendar = (role, from, to, forUserId = null, childStudentId = null) =>
  role === "PARENT"
    ? API.get(`/parent/children/${childStudentId}/sessions/calendar`, { params: { from, to } })
    : role === "STUDENT"
    ? API.get(`/student/sessions/calendar`, { params: { from, to } })
    : API.get(`${baseFor(role)}/sessions/calendar`, {
        params: { from, to, ...(forUserId != null ? { forUserId } : {}) },
      });

// Helper: build full name from a UserResponse object
const fullName = (u) =>
  [u.firstName, u.middleName, u.lastName].filter(Boolean).join(" ").trim() ||
  u.username ||
  `#${u.id}`;

/**
 * Load the list of users whose calendar the current user can browse.
 * Returns  [{ id, label, type }]  where type is "COACH" | "STUDENT".
 * Returns an empty array for STUDENT role.
 */
export const listCalendarUsers = (role) => {
  if (role === "COACH") {
    return API.get("/coach/my-students").then((res) =>
      (res.data || []).map((u) => ({
        id: u.id,
        label: u.label,
        type: "STUDENT",
      })),
    );
  }
  if (role === "ADMIN" || role === "MANAGER") {
    const base = role === "ADMIN" ? "/admin" : "/manager";
    return Promise.all([
      API.get(`${base}/users`, { params: { role: "COACH" } }),
      API.get(`${base}/users`, { params: { role: "STUDENT" } }),
    ]).then(([coaches, students]) => [
      ...coaches.data.map((u) => ({
        id: u.id,
        label: fullName(u),
        type: "COACH",
      })),
      ...students.data.map((u) => ({
        id: u.id,
        label: fullName(u),
        type: "STUDENT",
      })),
    ]);
  }
  return Promise.resolve([]);
};
